import { render, staticRenderFns } from "./tooltip_demo.vue?vue&type=template&id=53d3604e&scoped=true&"
import script from "./tooltip_demo.vue?vue&type=script&lang=ts&"
export * from "./tooltip_demo.vue?vue&type=script&lang=ts&"
import style0 from "./tooltip_demo.vue?vue&type=style&index=0&id=53d3604e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d3604e",
  null
  
)

export default component.exports